<template>
    <div>
        <a-form ref="codeForm" :model="codeForm" :rules="rules" class="phone">
            <a-form-item v-bind="validateInfos.mob">
                <a-input v-model:value="codeForm.mob" size="large" onkeyup="this.value=this.value.replace(/\D/g,'')"
                    placeholder="手机号">
                    <template #prefix>
                        <MobileOutlined style="color: rgba(0, 0, 0, 0.25)" />
                    </template>
                </a-input>
            </a-form-item>
            <a-form-item v-bind="validateInfos.verkey">
                <a-input v-model:value="codeForm.verkey" size="large" @change="handlerUser('3')"
                    style="width: 70%; float: left" placeholder="验证码">
                    <template #prefix>
                        <UserOutlined type="user" style="color: rgba(0, 0, 0, 0.25)" />
                    </template>
                </a-input>
                <a-button v-if="codeShow" type="primary" @click="handlerVerKey(codeForm)" class="code">
                    {{ passText }}
                </a-button>
                <a-button v-else disabled class="code">
                    {{ times }}秒后重试
                </a-button>
            </a-form-item>
            <div class="remenber"></div>
            <a-form-item>
                <a-button :loading="loading" style="width: 100%; height: 40px" @click="loginPhone(codeForm)"
                    type="primary">{{
                        button_login }}</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
import { login, getLic } from "@/views/login/api";
import { listenKeyDownFunc } from "@/utils";
import { $post, $get } from "@/utils/request";
import { phoneTips, verkeyCode } from "@/views/components/api/api";
import { message } from "ant-design-vue";
import { UserOutlined, MobileOutlined } from "@ant-design/icons-vue";
import { reactive, toRaw } from 'vue';
import { Form } from 'ant-design-vue';
const useForm = Form.useForm;
export default {
    components: { UserOutlined, MobileOutlined },
    props: {
        terms: '',
        is_user: '',
    },
    data() {
        const codeForm = reactive({
            mob: "",
            verkey: "",
            typ: "1",
        });
        const rules = reactive({
            mob: [
                { required: true, validator: phoneTips },
            ],
            verkey: [
                { required: true, validator: verkeyCode },
                { min: 6, max: 6, message: "验证码格式为6位数", trigger: "blur" },
            ],
        });
        const { validate, validateInfos } = useForm(codeForm, rules);
        return {
            codeForm,
            validate,
            validateInfos,
            rules,
            loading: false,
            button_login: "登录",
            codeShow: true,
            times: 60,
            newtimes: 60,
            passText: "获取验证码",
        };
    },
    methods: {
        // 获取验证码
        handlerVerKey(s) {
            if (s.mob != '' && s.mob.length == '11') {
                $post({
                    url: "auth/getVerCode",
                    params: s,
                }).then((res) => {
                    message.success("发送成功");
                    this.codeShow = false;
                    setInterval(() => {
                        if (this.times > 0 && this.times <= 60) {
                            this.times--;
                        } else {
                            this.codeShow = true;
                            this.passText = "重新发送";
                            this.times = 60;
                        }
                    }, 1000);
                }).catch((err) => {
                    message.error(err);
                });
            } else if (s.mob.length < 11) {
                message.error('请输入正确的手机号')
            } else if (s.mob == '') {
                message.error('请先输入手机号')
            }
        },
        loginPhone(s) {
            this.validate().then(() => {
                this.handlerLogin(s)
            }).catch(err => {
                this.loading = false;
            });
        },
        handlerLogin(s) {
            if (this.terms) {
                // getLic().then((res) => {
                // if (res.code) {
                login(s, (token) => {
                    this.loading = true;
                    this.button_login = "登录中";
                    this.$store.dispatch("user/login", token).then(() => {
                        const _redirect = this.$route.query.redirect;
                        const status = this.$route.query.status;
                        const title = this.$route.query.title;
                        const proj_type = this.$route.query.proj_type;
                        const oper_type = this.$route.query.oper_type;
                        const page = this.$route.query.page;
                        const perpage = this.$route.query.perpage;
                        if (_redirect) {
                            if (_redirect == "no-permission" || _redirect == "/no-permission") {
                                this.$router.push({ path: "/home/workspace" });
                            } else if (_redirect == "404" || _redirect == "/404") {
                                this.$router.push({ path: "/home/workspace" });
                            } else if (_redirect == "modify" || _redirect == "/modify") {
                                this.$router.push({ path: "/home/workspace" });
                            } else if (_redirect == "refresh" || _redirect == "/refresh") {
                                this.$router.push({ path: "/home/workspace" });
                            } else if (_redirect.indexOf('mbr403') > -1) {
                                this.$router.push({ path: "/home/workspace" });
                            } else {
                                if (_redirect.indexOf('?id=') > -1) {
                                    let i = _redirect.indexOf('?id=')
                                    let id = _redirect.slice(i + 4)
                                    this.$router.push({
                                        path: _redirect,
                                        query: { id, status, title, proj_type, oper_type, page, perpage },
                                    });
                                } else if (_redirect.indexOf('?sub_id=') > -1) {
                                    let i = _redirect.indexOf('?sub_id=')
                                    let sub_id = _redirect.slice(i + 8)
                                    this.$router.push({
                                        path: _redirect,
                                        query: { sub_id, status, title, proj_type, oper_type, page, perpage },
                                    });
                                } else {
                                    this.$router.push({
                                        path: _redirect,
                                        query: { status, title, proj_type, oper_type, page, perpage },
                                    });
                                }
                            }
                            this.loading = false;
                        } else {
                            this.$router.push({ path: "/home/workspace" });
                            this.loading = false;
                        }
                    }).catch((err) => {
                        this.loading = false;
                        this.button_login = "登录";
                    });
                });
                // } else {
                //     message.error(res.msg)
                // }
                // }).catch((err) => {
                //     message.error(err)
                // })

            } else {
                this.$emit("handlerClause")
            }
        },
        handlerUser(value) {
            if (value == "1") {
                this.codeForm.username = this.codeForm.username.replaceAll(" ", "");
            } else if (value == "2") {
                this.codeForm.password = this.codeForm.password.replaceAll(" ", "");
            } else if (value == "3") {
                this.codeForm.verkey = this.codeForm.verkey.replaceAll(" ", "");
            }
        },
    },
    mounted() {
        localStorage.setItem("query", JSON.stringify({}));
        listenKeyDownFunc({
            keyCode: 13,
            callback: () => {
                if (!this.is_user) {
                    this.loginPhone(this.codeForm);
                }
            },
        });
    },
}
</script>

<style></style>